module.exports = __webpack_public_path__ + "static/media/operational1.60787cf6.png";